<template>
  <div class="mb-2 flex flex-wrap gap-3 p-3">
    <div
      v-for="(filename, idx) in displaySymbols"
      :key="idx"
      class="w-16 md:w-24"
    >
      <div class="flex flex-col">
        <FunctionIcon :icon="filename" class="m-2 !h-10 !w-auto md:!h-12" />
        <div
          v-if="iconTexts[countryCode]?.[filename]"
          class="break-words text-center text-sm leading-3"
        >
          {{ iconTexts[countryCode]?.[filename] }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import iconTexts from './ProductFunctionIconsTexts'
import {
  hasFunctionIconAsset,
  resolveCountryCode,
} from '~/config/functionIcons'

const props = defineProps({
  symbols: {
    type: Array as PropType<string[]>,
    default: () => [],
  },
})
const currentShop = useCurrentShop()
const countryCode = resolveCountryCode(currentShop.value.locale)

const displaySymbols = computed(() =>
  props.symbols.filter((s) => hasFunctionIconAsset(s)).slice(0, 5),
)
</script>
